package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

@Serializable
internal sealed interface ActionDto {
    @Serializable
    data object Default : ActionDto

    @Serializable
    @SerialName("video")
    data class Video(
        @SerialName("url") val url: String,
    ) : ActionDto

    @Serializable
    @SerialName("insight")
    data class Insight(
        @SerialName("id") val id: String,
    ) : ActionDto

    @Serializable
    @SerialName("recipe")
    data class Recipe(
        @SerialName("id") val id: String,
    ) : ActionDto

    @Serializable
    @SerialName("category")
    data class Category(
        @SerialName("id") val id: String,
    ) : ActionDto

    @Serializable
    @SerialName("workout")
    data class Workout(
        @SerialName("id") val id: String,
    ) : ActionDto

    @Serializable
    @SerialName("shopping_list")
    data class ShoppingList(
        @SerialName("shopping_list") val shoppingList: ShoppingListDto,
    ) : ActionDto

    @Serializable
    @SerialName("anchor")
    data class Anchor(
        @SerialName("id") val id: String,
    ) : ActionDto

    @Serializable
    @SerialName("log_meal")
    data class LogMeal(
        @SerialName("nutrition_data") val nutrition: MealNutritionDto,
    ) : ActionDto

    @Serializable
    @SerialName("update_food_preferences")
    data object UpdateFoodPreferences : ActionDto

    @Serializable
    @SerialName("favorite")
    data class Favorite(
        @SerialName("preview") val content: ContentPreviewDto,
    ) : ActionDto

    @Serializable
    @SerialName("share")
    data object Share : ActionDto

    companion object {
        val module = SerializersModule {
            polymorphic(ActionDto::class) {
                subclass(Video::class, Video.serializer())
                subclass(Insight::class, Insight.serializer())
                subclass(Recipe::class, Recipe.serializer())
                subclass(Category::class, Category.serializer())
                subclass(Workout::class, Workout.serializer())
                subclass(ShoppingList::class, ShoppingList.serializer())
                subclass(Anchor::class, Anchor.serializer())
                subclass(LogMeal::class, LogMeal.serializer())
                subclass(UpdateFoodPreferences::class, UpdateFoodPreferences.serializer())
                subclass(Favorite::class, Favorite.serializer())
                subclass(Share::class, Share.serializer())
                defaultDeserializer { Default.serializer() }
            }
        }
    }
}
